<mat-label class="subHeading">Sum Insured<span *ngIf="isRequired" class="star">*</span></mat-label>
<div formGroupName="sum_insured" class="d-flex align-items-center mt-2" style="gap: 10px;">
    <input formControlName="from" [maxlength]="15" type="text" class="w-50 m-0" placeholder="From" appNumberOnly>
    -
    <input formControlName="to" [maxlength]="15" type="text" class="w-50 m-0" placeholder="To" appNumberOnly>
</div>
<p
    class="text-danger"
    *ngIf="sumInsuredForm.controls['from'].hasError('small') || sumInsuredForm.controls['to'].hasError('small')"
>
Invalid range for values
</p>
